'use strict';

document.addEventListener('DOMContentLoaded', () => {
    $('body').on('click', '.js-recipe-add-all-to-cart', function click(e) {
        e.preventDefault();
        const url = $(this).attr('href');
        $.spinner().start();// eslint-disable-line vars-on-top
        $.ajax({
            url: url,
            method: 'GET',
            dataType: 'json',
            success(response) {
                $.spinner().stop();
                if (response.status) {
                    $('.minicart').trigger('count:update', response.cart);
                    $('body').trigger('product:afterAddToCart', response);
                    $('.minicart-total span[data-subtotal]').text(response.cart.totals.grandTotal);
                }
            },
            error() {
                $.spinner().stop();
            }
        });
    });
});
